export const environment = {
			production: false,
			apiEnvironment: 'Dev',
			apiRoot: 'https://api.trbportal.com',
			nodeApiRoot: 'https://api.prod.portal.trb.bank',
			cognitoRegion: 'us-east-1',
			cognitoUserPoolId: 'us-east-1_DqiwKmEQy',
			cognitoAppClientId: '5eckde4ksaj7llppbojpbchda5',
			webSocketApiUri: 'wss://websocket.prod.internal.trb.bank/',
			clientAppUri: 'https://www.prod.portal.trb.bank',
			extIdentityProviderRoot: 'https://auth.prod.portal.trb.bank',
			plaidVerificationTemplate: 'idvtmp_6gt2TmimzGV6Kt',
			plaidEnv: 'production',
			consoleLogLevel: 'NONE'
		};
		